import { create } from 'zustand';
import api from '../lib/api';

export interface ProjectFinancials {
  id: string;
  name: string;
  clientName: string | null;
  budget: number;
  status: string;
  cost: number;
  margin: number;
}

export interface FinanceSummary {
  totalRevenue: number;
  monthlyRunRate: number;
  averageMargin: number;
  overdueInvoices: number;
}

interface FinanceState {
  summary: FinanceSummary | null;
  projects: ProjectFinancials[];
  loading: boolean;
  error: string | null;
  fetchFinanceData: () => Promise<void>;
}

export const useFinanceStore = create<FinanceState>((set) => ({
  summary: null,
  projects: [],
  loading: false,
  error: null,

  fetchFinanceData: async () => {
    set({ loading: true, error: null });
    try {
      const [summaryRes, projectsRes] = await Promise.all([
        api.get('/work/finance/summary'),
        api.get('/work/finance/projects')
      ]);
      set({ 
        summary: summaryRes.data, 
        projects: projectsRes.data,
        loading: false 
      });
    } catch (error: any) {
      set({ error: error.message, loading: false });
    }
  }
}));
